// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:768px){.text-wrapper[data-v-7da32372]{max-width:90%}}@media screen and (min-width:769px){.text-wrapper[data-v-7da32372]{max-width:75%}}.modal-card-body[data-v-7da32372]{border-top-left-radius:6px;border-top-right-radius:6px}.is-flex>span[data-v-7da32372]{display:flex}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
